import Swimlane, { SwimlaneItem } from "components/Swimlane/Swimlane";

const MetaDocNoContextScreen = () => {
  return (
    <div className="metadoc-page">
      <Swimlane>
        <SwimlaneItem heading="Meta Document">
          <div className="metadoc-empty-state">
            <div className="metadoc-error">
              <span className="material-icons metadoc-error-icon">
                error_outline
              </span>
              <p className="metadoc-error-message">No file context available</p>
              <p className="metadoc-error-detail">
                Unable to determine file ID from current workspace
              </p>
            </div>
          </div>
        </SwimlaneItem>
      </Swimlane>
    </div>
  );
};

export default MetaDocNoContextScreen;
